import React from 'react'
import Row from '../../../../bootstrap/component/Row'
import Checkbox from '../../../../form/component/Checkbox'
import Column from '../../../../bootstrap/component/Column'
import Radio from '../../../../form/component/Radio'
import ContentBoxWithoutHeader from '../../../../layout/component/ContentBoxWithoutHeader'
import ContentBoxBody from '../../../../layout/component/ContentBoxBody'

const ANASTHESIE = [
    {
        label: 'Infiltrationsanästhesie',
        name: 'anasthesieInfiltrationsanaesthesie',
    },
    {
        label: 'Leitungsanästhesie',
        name: 'anasthesieLeitungsanaesthesie',
    },
]

const ANZAHL_DER_AMPULLEN = [
    {
        label: '1',
        name: 'anzahlDerAmpullen',
    },
    {
        label: '2',
        name: 'anzahlDerAmpullen',
    },
    {
        label: '3',
        name: 'anzahlDerAmpullen',
    },
    {
        label: '4',
        name: 'anzahlDerAmpullen',
    },
    {
        label: '5',
        name: 'anzahlDerAmpullen',
    },
]

const VOLLNARKOSE = [
    {
        label: 'ja',
        name: 'vollnarkose',
    },
    {
        label: 'nein',
        name: 'vollnarkose',
    },
]

const INZISION = [
    {
        label: 'Flapless',
        name: 'inzisionFlapless',
    },
    {
        label: 'Spaltlappen',
        name: 'inzisionSpaltlappen',
    },
    {
        label: 'Volllappen',
        name: 'inzisionVolllappen',
    },
]

const CHIRURGISCHER_EINGRIFF = [
    {
        label: 'Einzeitiges Verfahren',
        name: 'chirurgischerEingriffEinzeitigesVerfahren',
    },
    {
        label: 'Zweizeitiges Verfahren (bitte Datum ins Kommentarfeld angeben)',
        name: 'chirurgischerEingriffZweizeitigesVerfahren',
    },
    {
        label: 'Geführte Chirurgie',
        name: 'chirurgischerEingriffGefuehrteChirurgie',
    },
    {
        label: 'Sofortbelastung',
        name: 'chirurgischerEingriffSofortbelastung',
    },
    {
        label: 'Zeitversetzte Belastung',
        name: 'chirurgischerEingriffZeitversetzteBelastung',
    },
]

const POSTOPERATIVES_ROENTGEN = [
    {
        label: 'ja',
        name: 'postoperativesRoentgen',
    },
    {
        label: 'nein',
        name: 'postoperativesRoentgen',
    },
]

const KONTROLLE = [
    {
        label: '7 Tage',
        name: 'kontrolle7Tage',
    },
    {
        label: '14 Tage',
        name: 'kontrolle14Tage',
    },
    {
        label: '3 Monate',
        name: 'kontrolle3Monate',
    },
    {
        label: '6 Monate',
        name: 'kontrolle6Monate',
    },
    {
        label: '1 Jahr',
        name: 'kontrolle1Jahr',
    },
    {
        label: '2 Jahre',
        name: 'kontrolle2Jahre',
    },
]

const ImplantSurgeryDocumentation = (props) => {
    const { anamnesis, changeAnamnesis, saveAnamnesis} = props

    const changeFormData = (name, value) => {
        changeAnamnesis('formData', {
            ...anamnesis.formData,
            [name]: value,
        }, anamnesis.templateKey)
    }

    return (
        <div className="surgeryDocumentation">
            <ContentBoxWithoutHeader>
                <ContentBoxBody>
                    <Row top="S">
                        <h2>Anästhesie</h2>
                    </Row>
                    <Row top="S">
                        {ANASTHESIE.map((documentation, index) => {
                            const isChecked = anamnesis.formData[documentation.name] && anamnesis.formData[documentation.name] === true
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Checkbox
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, !isChecked)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        name="isChecked"
                                        object={{ isChecked }}>
                                        {documentation.label}
                                    </Checkbox>
                                </Column>
                            )
                        })}
                    </Row>
                    <br />
                    Anzahl der Ampullen
                    <Row top="S">
                        {ANZAHL_DER_AMPULLEN.map((documentation, index) => {
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Radio
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, documentation.label)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        value={documentation.label}
                                        name={documentation.name}
                                        object={ anamnesis.formData }>
                                        {documentation.label}
                                    </Radio>
                                </Column>
                            )
                        })}
                    </Row>
                    <br />
                    Vollnarkose
                    <Row top="S">
                        {VOLLNARKOSE.map((documentation, index) => {
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Radio
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, documentation.label)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        value={documentation.label}
                                        name={documentation.name}
                                        object={ anamnesis.formData }>
                                        {documentation.label}
                                    </Radio>
                                </Column>
                            )
                        })}
                    </Row>
                    <Row top="S">
                        <h2>Inzision</h2>
                    </Row>
                    <Row top="S">
                        {INZISION.map((documentation, index) => {
                            const isChecked = anamnesis.formData[documentation.name] && anamnesis.formData[documentation.name] === true
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Checkbox
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, !isChecked)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        name="isChecked"
                                        object={{ isChecked }}>
                                        {documentation.label}
                                    </Checkbox>
                                </Column>
                            )
                        })}
                    </Row>
                    <Row top="S">
                        <h2>Chirurgischer Eingriff</h2>
                    </Row>
                    <Row top="S">
                        {CHIRURGISCHER_EINGRIFF.map((documentation, index) => {
                            const isChecked = anamnesis.formData[documentation.name] && anamnesis.formData[documentation.name] === true
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Checkbox
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, !isChecked)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        name="isChecked"
                                        object={{ isChecked }}>
                                        {documentation.label}
                                    </Checkbox>
                                </Column>
                            )
                        })}
                    </Row>
                    <Row top="S">
                        <h2>Postoperatives Röntgen</h2>
                    </Row>
                    <Row top="S">
                        {POSTOPERATIVES_ROENTGEN.map((documentation, index) => {
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Radio
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, documentation.label)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        value={documentation.label}
                                        name={documentation.name}
                                        object={ anamnesis.formData }>
                                        {documentation.label}
                                    </Radio>
                                </Column>
                            )
                        })}
                    </Row>
                    <Row top="S">
                        <h2>Kontrolle und Nachsorge der Implantatbehandlung</h2>
                    </Row>
                    <Row top="S">
                        {KONTROLLE.map((documentation, index) => {
                            const isChecked = anamnesis.formData[documentation.name] && anamnesis.formData[documentation.name] === true
                            return (
                                <Column key={documentation.name+index} size={5}>
                                    <Checkbox
                                        key={'field-'+documentation.name+index}
                                        onChange={() => {
                                            changeFormData(documentation.name, !isChecked)
                                            saveAnamnesis(anamnesis.templateKey)
                                        }
                                        }
                                        name="isChecked"
                                        object={{ isChecked }}>
                                        {documentation.label}
                                    </Checkbox>
                                </Column>
                            )
                        })}
                    </Row>
                </ContentBoxBody>
            </ContentBoxWithoutHeader>
        </div>
    )
}

export default ImplantSurgeryDocumentation



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/ImplantSurgeryDocumentation.js